define(function(require, exports, module) {
    'use strict';

    const $ = require('j');

    module.exports = {

        events: {
            'tap .fn-field-tooltip-icon': 'handleTooltipToggle',
            'keydown .fn-field-tooltip-icon': 'onTooltipIconKeyDown',
            'tap .fn-field-tooltip-info': 'handleTooltipInfoClick'
        },

        handleTooltipInfoClick: function(event) {
            event.preventDefault();
            event.stopPropagation();
        },

        onTooltipIconKeyDown: function(event) {
            const { key } = event;

            if (key === 'Enter') {
                this.handleTooltipToggle(event);
            }
        },

        handleTooltipToggle: function(event) {
            event.preventDefault();
            event.stopPropagation();

            const currentTooltip = event.target.closest('.fn-field-tooltip');
            const show = !$(currentTooltip).hasClass('opened');
            const info = $(currentTooltip).find('.fn-field-tooltip-info');
            const icon = $(currentTooltip).find('.fn-field-tooltip-icon');

            this.closeTooltip();

            if (show) {
                this.fitTooltip(info, icon);
            }

            $(currentTooltip).toggleClass('opened', show);
        },

        fitTooltip: function(tooltip, icon) {
            let top;
            const tooltipRect = tooltip[0].getBoundingClientRect();
            const { top: portletTop, right: portletRight } = this.el.closest('.fn-portlet-wrapper').getBoundingClientRect();

            if (Playtech.API.page.isPageInPopupUrl()) {
                const popupTitleHeight = this.el.closest('.popup-modal__inner-content')?.previousSibling?.offsetHeight;

                top = popupTitleHeight > portletTop ? popupTitleHeight : portletTop;
            } else {
                const headerHeight = $('.header')[0].offsetHeight;

                top = headerHeight > portletTop ? headerHeight : portletTop;
            }

            tooltip.toggleClass('bottom-tooltip', tooltipRect.top < top);
            icon.toggleClass('bottom-arrow', tooltipRect.top < top);

            if (tooltipRect.right > portletRight) {
                tooltip.css('left', `calc(-2rem - ${tooltipRect.right - portletRight}px)`);
            }
        },

        closeTooltip: function() {
            this.$('.fn-field-tooltip').removeClass('opened');
            this.$('.fn-field-tooltip-info').removeClass('bottom-tooltip').css('left', '-1rem');
        }
    };
});
